export default __webpack_public_path__ + "static/media/edit.edce86de.svg";